export default __webpack_public_path__ + "static/media/upload.a706b3f5.svg";